import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
} from '@/lib/graphql-query-builder';

/** Latest change first, like the old `mbm-project-list` (`GetMbmProjectList`) `{ LastUpdateDate: -1 }` sort. */
export const buildGetMbmProjectsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    MbmProjects: getMbmProjects(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral([{ field: 'LastUpdatedDate', direction: 'DESC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        ProjectId
        ProjectName
        CustomerName
      }
    }
  }
`;
